import { useGetPickupChildShippingsQuery } from '../services/pickupTransitions.endpoints';
import { skipToken } from '@reduxjs/toolkit/query';
import { PickUpChildShipping } from '../models';

interface UsePickUpChildrenProps {
  shippingNumber?: number | string;
  page: number;
  pageSize: number;
  skip?: boolean;
}

const usePickUpChildren = ({ shippingNumber, page, pageSize, skip = false }: UsePickUpChildrenProps) => {
  const { data, isLoading, error } = useGetPickupChildShippingsQuery(
    skip || !shippingNumber ? skipToken : { shippingNumber, page, pageSize }
  );

  return {
    children: (data?.items || []) as PickUpChildShipping[],
    totalItems: data?.count ?? 0,
    totalPages: data ? Math.ceil(data.count / pageSize) : 0,
    isLoading,
    error,
  };
};

export default usePickUpChildren;
